module.exports = __webpack_public_path__ + "img/Logo_la_Padroneta_normal.804d2b0f.png";